import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ButtonTabs from "../../Components/ButtonTabs/ButtonTabs";
import { useDispatch, useSelector } from "react-redux";
import LoanModuleHomePage from "./LoanModuleHomePage";
import ApplyLoan from "./ApplyLoan";
import SuretyApproval from "./Surety/SuretyApproval";
import { getContext } from "../../Helpers/Context/Context";
import { APICall } from "../../Helpers/Network/APICalls";
import { loanModuleGetPersonalDetailsByMemberId } from "../../Helpers/APIEndPoints/EndPoints";
import { useLocation } from "react-router-dom";
import { setIsLoanParams } from "../../Redux/Actions/LoanModuleAction";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} aria-disabled={false} {...other}>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const LoanModule = () => {
  
  const dispatch = useDispatch();
  const context = getContext();
  const [value, setValue] = React.useState(0);
  const [statusData, setStatusData] = React.useState<any>();
  let MemberId = context.MemberId;
  const { state } = useLocation();

  useEffect(() => {
    if (state.Id != 0 && state.Id != null) {
      getPersonalDetailsByIdApiCallll();
    } else {
      // localStorage.setItem("LoanType", "");
      dispatch(setIsLoanParams({ LoanId: 0, MemberId: 0 }));
    }
  }, []);

  const tabs = [
    {
      label: "Home",
      value: { ...a11yProps(0) },
    },
    {
      label: "Apply for Loan",
      value: { ...a11yProps(1) },
    },
  ];

  const getPersonalDetailsByIdApiCallll = async () => {
    
    let requestParams = { LoanId: state.Id, MemberId: MemberId };
    dispatch(setIsLoanParams({ LoanId: state.Id, MemberId: MemberId }));
    
    const res = await APICall(loanModuleGetPersonalDetailsByMemberId, requestParams);
    if (res.Message === "Ok" && res.Data !== null) {
      setStatusData(res.Data);
      setValue(1);
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    // setTabsStatus((prevStatus) => prevStatus.map((_, index) => index <= newValue));
  };

  return (
    <Box sx={{ width: "100%" }}>
      <ButtonTabs value={value} handleChange={handleChange} tabs={tabs} />
      <CustomTabPanel value={value} index={0}>
        <LoanModuleHomePage />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <ApplyLoan statusData={statusData} />
      </CustomTabPanel>
    </Box>
  );
};

export default LoanModule;
